import { useSelector } from "react-redux";
import React from 'react';
import "../../../../Assets/Scss/newHome2.scss";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../../Config/axiosInstance";


export default function MostTrending({n}) {

const { topRatedStores } = useSelector((state) => state.Stores);


	return(
		       
		<div id="mt-h4" style={{height:"300px"}}>
			{topRatedStores.slice(n - 12, n).map((store, i)=>{
				return(
          <div style={{ padding:"5px"}}>
                <Link to={`/store/${store.store_details.slug}`} >
    <img
      src={`${BASE_URL}/${store?.store_details?.image}`}
      alt=""
      loading="lazy"
      style={{width:"100%", height:"100%", border:"1px solid #9CA3AF50", borderRadius:'15px'}}
    />
    </Link>
    <div>
    </div>
      </div>

					)
			})}
			</div>
	)
}
